import React from 'react';
import Button from "../form/Button";
const PriceingPlanItem = ({data}) => {
  return (
    <div className="relative shadow-sm bg-white border-2 border-[#F4F7FA] px-5 xs:px-7 py-5 rounded-lg">
        <div className="flex flex-col space-y-3 xs:space-y-5 xl:space-y-8  relative max-w-[340px] w-full mx-auto">
            {data.title &&
              <h4 className="font-PlusJakartaSans font-bold text-sm text-dark-teal-300 uppercase tracking-widest">{data.title}</h4>
            }
            {data.price &&
              <div className="text-slate-950 text-xs lg:text-sm xl:text-base font-medium font-PlusJakartaSans capitalize"><span className="text-lg xl:text-xl 2xl:text-2xl font-bold">$</span><span className="text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl font-bold">{data.price}</span>/year</div>
            }
            {data.talk &&
              <div className="text-[#20A17F] text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl font-bold font-PlusJakartaSans capitalize">{data.talk}</div>
            }
            {data.description &&
              <div className="text-gray-400 text-sm font-PlusJakartaSans tracking-tight">{data.description}</div>
            }
            
            <div className="relative">
                <Button
                    buttonLabel={data.btnname}
                    buttonTarget="_blank"
                    // buttonClasses="!bg-dark-teal-500 !text-base xl:!text-lg lg:h-10 xl:h-14 !px-6"
                    buttonClasses={data.buttonClasses}
                    buttonLabelClasses="capitalize lg:!text-base xl:!text-lg tracking-wider !font-bold !font-PlusJakartaSans"
                    buttonIconPosition="right"
                    buttonIcon="fa-light fa-arrow-right"
                    buttonHasLink={true}
                    buttonLink={data.link}
                />
            </div>
        </div>
    </div>
  );
};

export default PriceingPlanItem;